module.exports = "<p>\n  updation-applicant-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component.html
// module id = ./src/app/applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component.html
// module chunks = main